import React from 'react';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { CabinQuickSearch, SectionHeader } from '../../common/components';

const BlockedPeriods = () => {
  return (
    <>
      <Helmet>
        <title>Hinnoittelu - Estetyt jaksot</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader Breadcrumbs={['Hinnoittelu']} Title="Estetyt jaksot" />
        <div className="my-48">
          <CabinQuickSearch
            NavigateUrl="/rates/blockedperiods"
            Subtitle="Hae kohde jonka estettyjä jaksoja haluat muokata"
            Title="Valitse kohde"
          />
        </div>
      </Container>
    </>
  );
};

export default BlockedPeriods;
